import { Stack, StackItem } from '@fluentui/react';
import { FluentProvider, Card, Caption1, Text, Tooltip } from '@fluentui/react-components';
import { Info20Filled } from '@fluentui/react-icons';
import { Dismiss12Regular } from '@fluentui/react-icons'; // Import Dismiss12Regular for the dismiss button
import React, { useState } from 'react';
import { messageTheme, primaryIcon } from '../../styles/customStyles';

export const InfoBar = (props: any) => {
    // State to handle visibility
    const [isVisible, setIsVisible] = useState(true);

    // Function to handle dismiss button click
    const handleDismiss = () => {
        setIsVisible(false); // Hide the InfoBar when clicked
    };

    const commonSpaces = (addSpace: boolean) => {
        return addSpace ? (
            <Stack tokens={{ childrenGap: 10 }}>
                <StackItem><Text /></StackItem>
                <StackItem><Text /></StackItem>
            </Stack>
        ) : null; // No space when addSpace is false
    };

    // Render InfoBar only if it's visible
    return isVisible ? (
        <>
            {commonSpaces(props.showSpaces)}
            <StackItem>
                <FluentProvider theme={messageTheme}>
                    <Card appearance="subtle" size="small">
                        <Stack tokens={{ childrenGap: 10 }} horizontal>
                            <StackItem>
                                <Stack tokens={{ childrenGap: 10 }}>
                                    <StackItem><Info20Filled {...primaryIcon} /></StackItem>
                                </Stack>
                            </StackItem>
                            <StackItem>
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                    <StackItem><Caption1>{props.title}</Caption1></StackItem>
                                    <StackItem>
                                        <Stack tokens={{ childrenGap: 3 }}>
                                            <StackItem><Text></Text></StackItem>
                                            <StackItem>
                                                <Tooltip withArrow content={"Hide Info bar"} relationship="description" positioning="above">
                                                    <Dismiss12Regular onClick={handleDismiss} style={{ cursor: 'pointer' }} />
                                                </Tooltip>
                                            </StackItem>
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </StackItem>
                        </Stack>
                    </Card>
                </FluentProvider>
            </StackItem>
            {commonSpaces(props.showSpaces)}
        </>
    ) : commonSpaces(props.showSpaces); 
    // ) : null; //if you don't want space when info bar closes then send null insted of commonSpaces.
};
